import { Box, Button, Dialog, FormControl, TextField, Typography, useTheme } from "@mui/material"
import { font } from "../../styles/font"
import { useEffect, useState } from "react";
import { useApplicationContext } from "../../context/ApplicationContext";
import { Entity_Label } from "../../constant/ApplicationVariables";
import { Trans, useTranslation } from "react-i18next";

export default function EditModuleDialog({ open, handleClose, handleConfirm, loading, setLoading }) {
  const { currentFolderData } = useApplicationContext();
  const theme = useTheme();
  const { t } = useTranslation("translation", { keyPrefix: "sidebar.folder" });

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission behavior
    handleContinue(); // Call your validation function
  };

  const handleChange = (e) => {
    if (e.target.name === "name") {
      setName(e.target.value);
    }
    else if (e.target.name === "description") {
      setDescription(e.target.value);
    }
  };

  const handleContinue = () => {
    if (name.trim() === "" || name.length < 3 || name.length > 20) {
      return setError({ ...error, name: "Name must be between 3 and 20 characters" });
    }

    let body = {
      name,
      description,
    }

    handleConfirm(body);
  }

  useEffect(() => {
    setName(currentFolderData?.name);
    setDescription(currentFolderData?.description);
  }, [currentFolderData]);

  // Determine button text color based on theme mode
  const getButtonTextColor = () => {
    return theme.palette.mode === 'light' ? '#ffffff' : '#000000';
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{ "& .MuiDialog-paper": { width: "100%", maxWidth: "400px" } }}
    >
      <Box className="flex flex-col gap-4 px-4 py-2">
        <Box className="flex items-center justify-between gap-4">
          <Typography 
            fontSize={font.size.fs_4} 
            color={theme.palette.primary.main}  // Primary color for header
          >
            <Trans
              t={t}
              i18nKey="edit"
              defaults="Edit {{moduleText}}" // optional defaultValue
              values={{ moduleText: Entity_Label.folder, }}
            />
          </Typography>
          <Typography 
            fontSize={font.size.fs_4} 
            color={theme.palette.text.secondary}
          >
            /{currentFolderData ? currentFolderData?.path : ""}
          </Typography>
        </Box>

        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          className="flex flex-col gap-4"
        >
          <FormControl>
            <TextField 
              name="name" 
              required 
              label="Name" 
              fullWidth 
              value={name} 
              onChange={handleChange} 
              error={error?.name && error?.name} 
              helperText={error?.name && error?.name} 
            />
          </FormControl>

          <FormControl>
            <TextField 
              name="description" 
              label="Description" 
              fullWidth 
              multiline 
              minRows={4} 
              maxRows={4} 
              value={description} 
              onChange={handleChange} 
              error={error?.description && error?.description} 
              helperText={error?.description && error?.description} 
            />
          </FormControl>
        </Box>

        <Box className="flex items-center justify-end gap-4">
          <Button 
            disabled={loading} 
            onClick={handleClose}
            sx={{
              backgroundColor: theme.palette.error.main,
              color: getButtonTextColor(),  // White in light, black in dark
              '&:hover': {
                backgroundColor: theme.palette.error.main,
              },
              '&:disabled': {
                backgroundColor: theme.palette.action.disabledBackground,
                color: theme.palette.action.disabled,
              }
            }}
          >
            {t("cancelText")}
          </Button>
          <Button 
            type="submit" 
            disabled={!name || loading} 
            onClick={handleContinue}
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: getButtonTextColor(),  // White in light, black in dark
              '&:hover': {
                backgroundColor: theme.palette.primary.main,
              },
              '&:disabled': {
                backgroundColor: theme.palette.action.disabledBackground,
                color: theme.palette.action.disabled,
              }
            }}
          >
            {t("continueText")}
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}